import { Stack, Table, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import { deepPurple } from "@mui/material/colors";
import { makeModeAwareAccentBackground } from "@entrilia/shared/utilities/colorHelper";
import { convertISODate } from "@entrilia/shared/utilities/dateUtils";
import { formatMoney } from "@entrilia/shared/utilities/formatters";
import type { InvoiceAgentInvoice } from "../../../../api/types/expenseManagementTypes";
import ObjectPageLink from "../../../entityFields/ObjectPageLink";

interface Props {
  title: string;
  invoices: InvoiceAgentInvoice[];
}

const InvoiceAgentInvoicesTable = ({ title, invoices }: Props) => {
  if (invoices.length === 0) {
    return null;
  }

  return (
    <Stack spacing={0.5}>
      <Typography variant="subtitle2">{title}</Typography>
      <Table>
        <TableBody>
          {invoices.map((invoice) => (
            <TableRow
              key={invoice.id}
              sx={(t) => ({
                bgcolor: invoice.mentioned ? makeModeAwareAccentBackground(t, deepPurple) : undefined,
              })}
            >
              <TableCell sx={{ whiteSpace: "nowrap", width: "25%" }}>
                {convertISODate(invoice.date, "d MMM yyyy")}
              </TableCell>
              <TableCell>
                <ObjectPageLink objectId={invoice.id} objectType="Invoice">
                  {invoice.invoiceNo ?? "Open invoice"}
                </ObjectPageLink>
              </TableCell>
              <TableCell align="right" sx={{ whiteSpace: "nowrap", width: "25%" }}>
                {invoice.amount !== undefined && invoice.currency ? formatMoney(invoice.amount, invoice.currency) : ""}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Stack>
  );
};

export default InvoiceAgentInvoicesTable;
